import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import CaseForwarder from './CaseForwarder';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import React from 'react';

loadDOMComponent({
	selector: 'react-case-forwarder',
	callback: ({ container, context }: any) => {
		const caseId = container.getAttribute('caseId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<CaseForwarder caseId={caseId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
